import { Tooltip } from '@odo/shared-ui';
import { AssigneeAvatar, UnassignedAvatar, type AssigneeAvatarSize } from './AssigneeAvatar';
import { AssigneeName } from './AssigneeName';
import { getAvatarColor, nameFromEmail } from './assigneeSelectorHelpers';

interface AssigneeDisplayProps {
    name?: string | null;
    email?: string | null;
    variant: 'avatar' | 'avatar-name';
    size?: AssigneeAvatarSize;
    isMe?: boolean;
    unassignedLabel?: string;
}

/** Read-only assignee: avatar (tooltip on it) or avatar plus compact name; dashed circle when nobody. */
export function AssigneeDisplay({
    name,
    email,
    variant,
    size = 'sm',
    isMe = false,
    unassignedLabel = 'Unassigned'
}: AssigneeDisplayProps) {
    const fullname = name || email;
    if (!fullname) {
        return variant === 'avatar' ? (
            <Tooltip content={unassignedLabel}>
                <span className="flex">
                    <UnassignedAvatar size={size} />
                </span>
            </Tooltip>
        ) : (
            <span className="flex min-w-0 items-center gap-1.5 text-gray-400">
                <UnassignedAvatar size={size} />
                <span className="truncate">{unassignedLabel}</span>
            </span>
        );
    }

    const initialsName = name || nameFromEmail(fullname);
    const avatar = (
        <AssigneeAvatar name={initialsName} color={getAvatarColor(initialsName)} size={size} />
    );
    if (variant === 'avatar') {
        return (
            <Tooltip content={fullname}>
                <span className="flex">{avatar}</span>
            </Tooltip>
        );
    }
    return (
        <span className="flex min-w-0 items-center gap-1.5 text-gray-700">
            {avatar}
            <AssigneeName fullname={fullname} isMe={isMe} />
        </span>
    );
}
